import PropTypes from 'prop-types'
import React from 'react'
import styles from './_elevation.css'

const propTypes = {
  routeId: PropTypes.string.isRequired,
}

export function Elevation (props) {
  return (
    <section className={styles.container}>
      <img className={styles.elevation} src={`/routes/print/${props.routeId}/elevation.png`} />
    </section>
  )
}

Elevation.propTypes = propTypes

export default Elevation
